module.exports = __webpack_public_path__ + "media/images/faces/tt-06978bff51f86d766f6d35bb46da11ce.jpeg";